var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{class:['loader-icon', { 'loader-icon--small': _vm.small }],attrs:{"src":require("@/assets/images/digger.png"),"alt":"Loading..."}})
}
var staticRenderFns = []

export { render, staticRenderFns }